import useSWR from 'swr';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AppContext } from 'providers/AppProvider';
import { isEmail, isPhoneNumber } from 'helpers';
import { Member } from 'types';

export function useParents() {
	const ctx = useContext(AppContext);
	const { config, http, navigate, state, t } = ctx;
	const { entityType, flowType } = useParams();
	const [formErrors, setFormErrors] = useState({} as any);
	const processId = `${state.context.processInfo?.agreementProcessId}`;
	const initiatorSsn = state.context.kennitala;
	const nextPage = `/${flowType}/${entityType}/mandate`;
	const urlMembers = `${config.API.member}/${processId}/GetMembers`;
	const { data, mutate } = useSWR<Member[]>(urlMembers);

	const submitForm = async () => {
		const email = (document.getElementsByName('email')[0] as HTMLInputElement).value;
		const phoneNumber = (document.getElementsByName('phone')[0] as HTMLInputElement).value;
		const errors: any = {};
		if (!isEmail(email)) {
			errors['email'] = t('INVALID_EMAIL');
		}
		if (!isPhoneNumber(phoneNumber)) {
			errors['phone'] = t('INVALID_PHONE_NUMBER');
		}
		if (Object.keys(errors).length) {
			setFormErrors(errors);
		} else {
			const kennitala = Array.isArray(data) && data[1] ? data[1].kennitala : null;
			const payload = { email, phoneNumber, kennitala, initiatorSsn };
			const updateURL = `${config.API.member}/${processId}/UpdateMemberEmail`;
			await http.put(updateURL, payload, undefined, t('submit'));
			await mutate();
			navigate(nextPage);
		}
	};

	useEffect(() => {
		Array.isArray(data) && data.length < 2 && navigate(nextPage);
	}, [data]); // eslint-disable-line

	return { ...ctx, data, formErrors, submitForm };
}
